import React from "react";
import Styles from './styles.module.scss';
import PublicNavigation from "../publicNavigation";
import LoginContent from "../loginContent";


const PublicHeader = () => {

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.pagePadding}`}>
                <PublicNavigation/>
                <LoginContent/>
            </div>
        </section>
    );
};

export default PublicHeader;
